import { render, staticRenderFns } from "./ManagerResetButton.vue?vue&type=template&id=97219128&scoped=true"
import script from "./ManagerResetButton.vue?vue&type=script&lang=js"
export * from "./ManagerResetButton.vue?vue&type=script&lang=js"
import style0 from "./ManagerResetButton.vue?vue&type=style&index=0&id=97219128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b4d2f5f63767a7c4cbcbe44ae7bf34d4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97219128",
  null
  
)

export default component.exports